<ng-lottie [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
